<template>
	<ListParameter />
</template>

<script>
import ListParameter from './ListParameter';

export default {
	name: 'ParameterIndex',
	components: {
		ListParameter,
	},
	data() {
		return {};
	},
};
</script>

<style></style>
